import { type AccessoryGroup, type AccordionItem, type SceneSelections } from "~/features/product-configurator/configurator-types";
export const ACCESSORY_GROUPS: AccessoryGroup[] = [{
  id: "sensors",
  label: "(DEBUG) Sensors",
  selectionKey: "sensor",
  options: [{
    id: "os-dome",
    title: "OS Dome",
    description: ""
  }, {
    id: "os0",
    title: "OS0",
    description: ""
  }, {
    id: "os0-rgb",
    title: "OS0 RGB",
    description: ""
  }, {
    id: "os1",
    title: "OS1",
    description: ""
  }, {
    id: "os1-max",
    title: "OS1 Max",
    description: ""
  }, {
    id: "os1-max-rgb",
    title: "OS1 Max RGB",
    description: ""
  }],
  defaultSelected: "os-dome"
}, {
  id: "caps",
  label: "Add Caps",
  selectionKey: "cap",
  options: [{
    id: "os0-cap",
    title: "OS0 Cap",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "os0-rgb-cap",
    title: "OS0 RGB Cap",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "os1-cap",
    title: "OS1 Cap",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "os1-max-cap",
    title: "OS1 Max Cap",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "os1-max-rgb-cap",
    title: "OS1 Max RGB Cap",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }],
  defaultSelected: "os0-cap"
}, {
  id: "baseplates",
  label: "Add Baseplates",
  selectionKey: "baseplate",
  options: [{
    id: "universal",
    title: "Universal Baseplate",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }],
  defaultSelected: "universal"
}, {
  id: "cables",
  label: "Add Cables",
  selectionKey: "cable",
  options: [{
    id: "pigtail",
    title: "Pigtail",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "y-junction",
    title: "Y-Junction",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "cable-a",
    title: "Cable A",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "cable-b",
    title: "Cable B",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "cable-c",
    title: "Cable C",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }, {
    id: "interface-box",
    title: "Interface Box",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."
  }]
}];
export const ACCORDION_ITEMS: AccordionItem[] = [{
  id: "documents",
  title: "Documents & Downloads"
}, {
  id: "lorem",
  title: "Lorem Ipsum"
}];
export function buildInitialSelections(groups: AccessoryGroup[] = ACCESSORY_GROUPS): Record<string, string> {
  return groups.reduce<Record<string, string>>((result, group) => {
    if (group.defaultSelected) {
      result[group.id] = group.defaultSelected;
    }
    return result;
  }, {});
}
export function buildSceneSelections(selections: Record<string, string>, groups: AccessoryGroup[] = ACCESSORY_GROUPS): SceneSelections {
  return groups.reduce<SceneSelections>((result, group) => {
    const selectedOption = selections[group.id];
    if (selectedOption) {
      result[group.selectionKey] = selectedOption;
    }
    return result;
  }, {});
}